/**
 * Created by Abner Sui on 12/15/2020
 * -------------------------------------
 */

import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { UtilsService } from '../../tamalelibs/services/utils.service';
import { AlertBtnTypes, AlertButton } from '../../widgets/alert-window/alert-window.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { BriefConfig } from '../../widgets/widgets.model';
import { TemplateBubbleService } from './template-bubble.service';
import { ControlConfigEvents, Template } from './template-configuration.model';

@Component({
    selector: 'control-shell',
    templateUrl: './control-shell.component.html',
    styleUrls: ['./control-shell.component.scss']
})
export class ControlShellComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input()
    config: Template;
    @Input()
    ableMoveUp: boolean;
    @Input()
    ableMoveDown: boolean;
    @Input()
    ableMoveLeft: boolean;
    @Input()
    ableMoveRight: boolean;
    @Input()
    selectedControl;
    @Input()
    invalidControlId: Array<string>;
    @Input()
    options: BriefConfig;

    @Output()
    movedown: EventEmitter<any> = new EventEmitter();
    @Output()
    moveleft: EventEmitter<any> = new EventEmitter();
    @Output()
    moveright: EventEmitter<any> = new EventEmitter();
    @Output()
    moveup: EventEmitter<any> = new EventEmitter();
    @Output()
    delete: EventEmitter<any> = new EventEmitter();
    @Output()
    widthchange: EventEmitter<any> = new EventEmitter();

    @ViewChild('componentContainer', { static: false, read: ViewContainerRef }) componentContainer: ViewContainerRef;

    hover = false;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _componentService: DynamicComponentService,
        private _utils: UtilsService,
        private _templateService: TemplateBubbleService,
        private _alertWindow: AlertWindowService,
    ) { }

    ngOnInit(): void {
        this._destroySubscriptions.push(
            this.options.actionSubject$.subscribe(action => {
                if (action.type === ControlConfigEvents.CHANGE_WIDTH && this.selectedControl && this.selectedControl.id === this.config.id) {
                    this.widthchange.emit(action.payload);
                }
            }),
        );
    }

    ngAfterViewInit(): void {
        const controlComponent: any = this._componentService.loadComponent(this.componentContainer, this.config.component, true);
        controlComponent.instance.config = this.config;
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    mouseEnter(event): void {
        this.hover = true;
    }

    mouseLeave(event): void {
        this.hover = false;
    }

    moveDown(event) {
        if (this.ableMoveDown) {
            this.movedown.emit(this.config);
            this._utils.emptyClick(event);
            this.mouseLeave(event);
        }
    }

    moveLeft(event) {
        if (this.ableMoveLeft) {
            this.moveleft.emit(this.config);
            this._utils.emptyClick(event);
            this.mouseLeave(event);
        }
    }

    moveRight(event) {
        if (this.ableMoveRight) {
            this.moveright.emit(this.config);
            this._utils.emptyClick(event);
            this.mouseLeave(event);
        }
    }

    moveUp(event) {
        if (this.ableMoveUp) {
            this.moveup.emit(this.config);
            this._utils.emptyClick(event);
            this.mouseLeave(event);
        }
    }

    onDelete(event) {
        const doDeletionFunc = () => {
            this.delete.emit(this.config);
            this._utils.emptyClick(event);
            this.mouseLeave(event);
        };
        if (this.config['fieldDefinitionId'] && this._templateService.isFieldInvolvedWithConfig(this.config['fieldDefinitionId'])) {
            const cancelBtn: AlertButton = {
                text: StringLiteralsPipe.translate('general.no'),
                type: AlertBtnTypes.tertiary
            };
            const confirmButton: AlertButton = {
                text: StringLiteralsPipe.translate('general.yes'),
                type: AlertBtnTypes.destructive
            };
            const popSub = this._alertWindow.
                custom(StringLiteralsPipe.translate('general.check_your_config'
                ), [StringLiteralsPipe.translate('workflow.field_in_automation'), StringLiteralsPipe.translate('workflow.sure_want_to_delete_field')], cancelBtn, confirmButton)
                .subscribe((result: boolean) => {
                    if (result) {
                        doDeletionFunc();
                    }
                    popSub.unsubscribe();
                });
        } else {
            doDeletionFunc();
        }
    }

}
